<template>
  <div>
    
    <div class="container verticalMiddle">
      <div class="carousel-caption blank">
        <h1 style="color: #003087; font-weight: 650; font-size: 60px;">SEDNA PARTNER PORTAL</h1>


          <div v-if="success"  >
            <b-row class="signin_border">
                <b-col align-self="center"  >
                 <h4>Check your email!</h4>
                 <div class="emailMessageText">
                   You will soon receive an email with a link back to this site.
                   <br />
                   Click it to log in.
                 </div>
              </b-col>
            </b-row>
          </div>

          <div v-else   >
            <b-row class="signin_border" align-h="center">
              <div v-if="!$auth.loading">
                <b-col align-self="center">
                  <b-button size="lg" block variant="primary" v-if="!$auth.isAuthenticated" v-on:click="login" v-bind:disabled="loading">Sign In</b-button>
                  <b-button size="lg" block variant="primary" v-if="$auth.isAuthenticated" v-on:click="redirect" v-bind:disabled="loading">Enter site</b-button>
                </b-col>      
              </div> 
            </b-row>
          </div>
          
      </div>
    </div>
    
    <loading-view v-if="loading" />
    <!--
    <b-jumbotron header="Sedna Partner Portal" lead="Enter your email below."
     text-variant="white" style="background-color:#003087; border: 1px solid green; font-family: Roboto">
      <p>Once you enter your email, we will send you a link to the portal.</p>
      <b-row style="width:75%">
        <b-col lg="8" md="8" sm="8">
          <b-input
            id = "input-username" 
            v-on="OnKeyPressed"
            v-model="username"
            placeholder="example@example.com" 
            v-bind:autofocus="true"
            trim>
          </b-input>  
        </b-col>
        <b-col lg="4" md="4" sm="4">
          <b-button block variant="primary" v-on:click="onLogin" v-bind:disabled="loading">Sign In</b-button>
        </b-col>
      </b-row>
    </b-jumbotron>
    -->
  </div>
</template>

<script>
import LoadingView from '@/components/common/LoadingView';
import { datadogLogs } from '@datadog/browser-logs';

const PortalApi = require("@brightoncromwell/portal-api");
const tokensApiInstance = new PortalApi.TokensApi();
import { getInstance } from '../auth';

export default {
  name: "signin-page",
  metaInfo: {
    title: "Signin"
  },
  components: {
    'loading-view': LoadingView
  },
  data() {
    return {
      username: "",
      loading: false,
      success: false
    };
  },
  methods: {
    onLogin: function() {
      this.loading = true;
      const tokenRequest = PortalApi.TokenRequest.constructFromObject({username: this.username});
      let opts = { tokenRequest };
      tokensApiInstance.tokensSendPost(opts, (error, data, response) => {
        this.loading = false;
        if (error) {
          console.error(error);
          this.$emit('onError', response)
        } else {
          this.success = true
        }
      });
    },
    checkAuth: async function() {
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if(instance.loading == false && instance.isAuthenticated){
          resolve("true");
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated){
            window.location.href = "/signin";
          }
        }
        else{
        instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              resolve("true");
            }
            // Redirect if the user isn't authenticated
            else if (loading == false && !instance.isAuthenticated){
              window.location.href = "/signin";
            }
        });
        }
      });
    },
    onKeyPressed: function(e) {
      if (e.keyCode === 13) {
        this.onLogin();
      }
    },
    login() {
        this.$auth.loginWithRedirect();
    },
    redirect() {
      window.location.href = "/signin";
    }
  },
  mounted() {
    datadogLogs.logger.info('Login page displayed', {});
    document.onreadystatechange = async function () {
            const instance = getInstance();
            instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              window.location.href = "#/rfqs";
            }
          });
        }
  },
  created() {
    const authCheck = this.checkAuth();
    if (authCheck == "true"){
      window.location.href = "#/rfqs";
    }
  }
};
</script>

<style scoped>
  .carousel-caption {
    position: unset;
  }

  .container {
    background-color: transparent;
  }

  .emailMessageText {
    color: #ddd;
    margin-top: 17px;
  }

  .verticalMiddle {
    min-height: 90%;
    min-height: 80vh;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
  }

  
</style>